import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/home/70-one.png';
import _imports_1 from '../assets/home/70-two.png';
import _imports_2 from '../assets/home/70-four.png';
import _imports_3 from '../assets/home/70-three.png';
import _imports_4 from '../assets/home/70-five.png';
import _imports_5 from '../assets/home/caseOne.png';
import _imports_6 from '../assets/home/caseTwo.png';
const _withScopeId = n => (_pushScopeId("data-v-1a530388"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "homeview-news"
};
const _hoisted_2 = {
  class: "news-box container"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-grow"
}, null, -1));
const _hoisted_4 = {
  key: 0,
  class: "newsBox"
};
const _hoisted_5 = {
  class: "newPic"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "newsTitle"
};
const _hoisted_8 = ["onMouseover", "onClick"];
const _hoisted_9 = {
  key: 1,
  class: "casesBox newsBox"
};
const _hoisted_10 = {
  class: "newPic"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "newsTitle"
};
const _hoisted_13 = ["onMouseover", "onClick"];
const _hoisted_14 = {
  class: "homeview-introduce"
};
const _hoisted_15 = {
  class: "introduce-box container"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "oneP"
}, "奇力士（武汉）智慧水务科技有限公司坐落于湖北武汉，深耕二次供水行业20余年，是一家集研发、生产、销售、运维于一体的高新技术企业，连续荣获“光谷瞪羚”企业，荣获国家专精特新“小巨人”企业称号。", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "twoP"
}, "自主研发生产静音、防淹等系列的二次供水智联设备，满足楼顶、楼中、地面、地下等多种二次供水应用场景，创新性使用防淹二次供水硬核技术打造“生命泵房，与中国建筑学会建筑给水排水研究分会成立全国“智能防淹二次供水设备研发中心，与中南建筑设计院成立“湖北省二次供水创新技术研究中心”、参与“十四五”国家重点研发课题，并主编或参编《智能防淹供水设备》《智能防淹供水设备应用技术规程》《二次供水泵房智慧运维标准》等多项国家和行业标准，奇力士一直致力于静音、防淹二次供水设备的深入研发和应用，开启二次供水安全的新时代。", -1));
const _hoisted_18 = {
  class: "button"
};
const _hoisted_19 = {
  class: "homeview-70"
};
const _hoisted_20 = {
  class: "box-70 container"
};
const _hoisted_21 = {
  class: "imgsDrawer"
};
const _hoisted_22 = {
  class: "img-box"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_24 = {
  class: "maskContent"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "深化设计", -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "奇力士拥有二次供水“生命泵房设计室”，与给排水专业设计院达成了战略合作协议，进一步探索二次供水设计的新模式，在规范的基础上，结合项目现场实际情况，深化方案设计，缔造良性循环的新行业链，保障不同市场的客户在二次供水领域，都能够享受到高价值的解决方案。", -1));
const _hoisted_27 = {
  class: "img-box"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "title"
}, "智联设备", -1));
const _hoisted_30 = {
  class: "maskContent"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "智联设备", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "奇力士自主研发生产高效静音防淹二次供水设备、永磁高效二次供水设备等多种系列的二次供水智联设备，满足楼顶、楼中、地面、地下等多种二次供水应用场景。", -1));
const _hoisted_33 = {
  class: "img-box"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "title"
}, "工程交付", -1));
const _hoisted_36 = {
  class: "maskContent"
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "工程交付", -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "奇力士拥有市政、机电施工资质和优质的施工队伍，基于对泵房各类设施设备的优化配置和建设基础上，融合了奇力士5000多个泵房建设经验，为客户提供：城乡给排水工程建设服务以及供水泵房“交钥匙”整体打造。并将用户感知、智能识别、人机互动等先进技术进行有效集成，提升了供水设备的使用寿命，规避了水污染风险，实现了设备的节能环保，保障了居民用水的便利与安全。", -1));
const _hoisted_39 = {
  class: "img-box"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "title"
}, "物联平台", -1));
const _hoisted_42 = {
  class: "maskContent"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "物联平台", -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "针对二次供水行业的特点，奇力士结合云计算、大数据、人工智能及物联网等先进的信息技术，将二次供水所涉及到的硬件、软件及从事供水行业近20年的经验进行有机结合，形成了一套集大数据分析、AI运维管理、二次供水全生命周期管理、多场景应用、监控调度全局看板、运维车辆管理等功能于一体的二次供水综合管理平台，达到了全面、智能、高效的运维管理服务。", -1));
const _hoisted_45 = {
  class: "img-box"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  class: "title"
}, "智慧运维", -1));
const _hoisted_48 = {
  class: "maskContent"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "智慧运维", -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "奇力士拥有丰富的泵房打造和维护经验，提供二次供水智慧运维解决方案，以二次供水综合管理平台为基础，充分利用物联网技术，实现智能运维。并打造二次供水运维实训基地，设置运维实训班，真实环境教学，实训+VR的操作体验，还原运维与抢修流程，助力于二次供水运维行业技术水平提升。", -1));
const _hoisted_51 = {
  class: "homeview-cases"
};
const _hoisted_52 = {
  class: "cases-box container"
};
const _hoisted_53 = {
  class: "casesPic"
};
const _hoisted_54 = {
  class: "img-box"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  width: "588",
  height: "440"
}, null, -1));
const _hoisted_56 = {
  class: "mask-box"
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "天顺园旧改工程", -1));
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "programeTitle"
}, "武汉水务集团旧改收官项目", -1));
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "content"
}, "天顺园旧改工程项目属于武汉水务集团旧改收官项目，该项目位于武汉市硚口区天顺园商业街 104 号，采用奇力士高效静音防淹二次供水设备（三级III），减少噪音对环境的影响，在高峰期供水仍保持稳定；水箱采用装配式水箱，无焊接点减少锈蚀，保证水质安全。", -1));
const _hoisted_60 = {
  class: "img-box"
};
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1));
const _hoisted_62 = {
  class: "mask-box"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "万松园小区北区新建静音泵房", -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "programeTitle"
}, "武汉市老旧小区重点改造项目", -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "content"
}, "万松小区北区新建静音泵房项目属于武汉市重点改造项目，该项目位于位于武汉市江汉区万松街白松社区雪松路万松小区北区，供水设备距离住宅仅2.6米，为保障居民日常生活不受影响，最终选择采用水箱+水泵的供水方式，设备采用奇力士高效静音防淹二次供水设备（三级III），既解决了高层水压供水不足的问题，又解决了老旧小区二次供水改造噪音扰民的痛点问题。", -1));
const _hoisted_66 = {
  class: "button-box"
};
const _hoisted_67 = {
  class: "homeview-partner"
};
const _hoisted_68 = {
  class: "partner-box container"
};
const _hoisted_69 = {
  class: "partners"
};
const _hoisted_70 = ["src"];
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下一页", -1));
const _hoisted_72 = [_hoisted_71];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_header_nav = _resolveComponent("header-nav");
  const _component_Banner = _resolveComponent("Banner");
  const _component_Header = _resolveComponent("Header");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_header_nav, {
    textColor: $setup.textColor,
    activeColor: $setup.activeColor,
    logoShow: $setup.logoShow,
    isChangeBg: $setup.logoShow ? 'transparent' : '#fff',
    isShadow: !$setup.logoShow
  }, null, 8, ["textColor", "activeColor", "logoShow", "isChangeBg", "isShadow"]), _createVNode(_component_Banner, {
    bannerList: $setup.bannerList
  }, null, 8, ["bannerList"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Header, {
    title: "企业新闻",
    content: "最新企业动态资讯为您推荐",
    textBg: "Corporate news"
  }), _createVNode(_component_el_menu, {
    "default-active": $setup.activeIndex,
    mode: "horizontal",
    ellipsis: false,
    onSelect: $setup.handleSelect
  }, {
    default: _withCtx(() => [_hoisted_3, _createVNode(_component_el_menu_item, {
      index: "0"
    }, {
      default: _withCtx(() => [_createTextVNode("新闻资讯")]),
      _: 1
    }), _createVNode(_component_el_menu_item, {
      index: "1"
    }, {
      default: _withCtx(() => [_createTextVNode("硬核案例")]),
      _: 1
    })]),
    _: 1
  }, 8, ["default-active", "onSelect"]), $setup.activeIndex === '0' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: $setup.newsList.list[$setup.activeNews]?.companyDynamicImg,
    alt: "",
    width: "400",
    height: "250"
  }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsList.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["oneNews", {
        activeNews: index === $setup.activeNews
      }]),
      key: item.companyDynamicId,
      onMouseover: _withModifiers($event => $setup.handerMouseover(index), ["stop"]),
      onClick: $event => $setup.open(item.companyDynamicSrc)
    }, [_createElementVNode("p", null, _toDisplayString(item.companyDynamicTitle), 1), _createElementVNode("p", null, _toDisplayString(item.companyDynamicTime?.slice(0, 10).replace(/-/g, ".")), 1)], 42, _hoisted_8);
  }), 128))])])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    src: $setup.caseShow.list[$setup.activeCase]?.projectImg,
    width: "400",
    height: "250",
    alt: ""
  }, null, 8, _hoisted_11)]), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.caseShow.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["oneNews", {
        activeNews: index === $setup.activeCase
      }]),
      key: item.projectId,
      onMouseover: _withModifiers($event => $setup.caseMouseOver(index), ["stop"]),
      onClick: $event => $setup.open(item.projectWechatSrc)
    }, [_createElementVNode("p", null, "【硬核案例】" + _toDisplayString(item.projectName), 1), _createElementVNode("p", null, _toDisplayString(item.projectTime?.slice(0, 10).replace(/-/g, ".")), 1)], 42, _hoisted_13);
  }), 128))])]))])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_Header, {
    title: "企业简介",
    content: "70年全过程二次供水系统服务商",
    textBg: "Company profile"
  }), _hoisted_16, _hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("button", {
    class: "defaultButton",
    onClick: _cache[0] || (_cache[0] = $event => $setup.router.push('/aboutUs'))
  }, "了解详情")])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_Header, {
    title: "70年全过程二次供水系统服务商",
    content: "高效静音防淹二供，选奇力士智慧水务",
    textBg: "Service provider"
  }), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_hoisted_25, _hoisted_26, _createElementVNode("button", {
    class: "borderButton",
    onClick: _cache[1] || (_cache[1] = $event => $setup.router.push('/deepDesign'))
  }, "了解详情")])]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _hoisted_29, _createElementVNode("div", _hoisted_30, [_hoisted_31, _hoisted_32, _createElementVNode("button", {
    class: "borderButton",
    onClick: _cache[2] || (_cache[2] = $event => $setup.router.push('/pumpSeries'))
  }, "了解详情")])]), _createElementVNode("div", _hoisted_33, [_hoisted_34, _hoisted_35, _createElementVNode("div", _hoisted_36, [_hoisted_37, _hoisted_38, _createElementVNode("button", {
    class: "borderButton",
    onClick: _cache[3] || (_cache[3] = $event => $setup.router.push('/dateReleased'))
  }, "了解详情")])]), _createElementVNode("div", _hoisted_39, [_hoisted_40, _hoisted_41, _createElementVNode("div", _hoisted_42, [_hoisted_43, _hoisted_44, _createElementVNode("button", {
    class: "borderButton",
    onClick: _cache[4] || (_cache[4] = $event => $setup.router.push('/managementPlatform'))
  }, "了解详情")])]), _createElementVNode("div", _hoisted_45, [_hoisted_46, _hoisted_47, _createElementVNode("div", _hoisted_48, [_hoisted_49, _hoisted_50, _createElementVNode("button", {
    class: "borderButton",
    onClick: _cache[5] || (_cache[5] = $event => $setup.router.push('/warmBoy'))
  }, "了解详情")])])])])]), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createVNode(_component_Header, {
    title: "工程案例",
    content: "质为点滴生命，安全供水70年",
    textBg: "Engineering case"
  }), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_hoisted_55, _createElementVNode("div", _hoisted_56, [_hoisted_57, _hoisted_58, _hoisted_59, _createElementVNode("button", {
    class: "borderButton",
    onClick: _cache[6] || (_cache[6] = (...args) => $setup.goToOtherPage1 && $setup.goToOtherPage1(...args))
  }, "了解详情")])]), _createElementVNode("div", _hoisted_60, [_hoisted_61, _createElementVNode("div", _hoisted_62, [_hoisted_63, _hoisted_64, _hoisted_65, _createElementVNode("button", {
    class: "borderButton",
    onClick: _cache[7] || (_cache[7] = (...args) => $setup.goToOtherPage2 && $setup.goToOtherPage2(...args))
  }, "了解详情")])])]), _createElementVNode("div", _hoisted_66, [_createElementVNode("button", {
    class: "defaultButton",
    onClick: _cache[8] || (_cache[8] = $event => $setup.router.push('/projectCase'))
  }, "更多案例展示")])])]), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createVNode(_component_Header, {
    title: "合作伙伴",
    content: "携手共进，助力未来",
    textBg: "COOPERATIVE PARTNER"
  }), _createElementVNode("div", _hoisted_69, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.partnerShow.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "oneBox",
      key: index
    }, [_createElementVNode("img", {
      src: item,
      alt: "",
      style: {
        "max-width": "180px"
      }
    }, null, 8, _hoisted_70)]);
  }), 128)), _createElementVNode("div", {
    class: "pageBox",
    onClick: _cache[9] || (_cache[9] = (...args) => $setup.goToNextPage && $setup.goToNextPage(...args))
  }, _hoisted_72)])])])], 64);
}